export const USER_STATUS_KEYS = [
    'first_time_buyer',
    'buyer_not_first_time',
    'property_to_sell',
    'property_to_let',
    'offer_on_own_property',
    'recently_sold',
    'looking_to_invest',
    'looking_to_rent',
    'curious_having_a_look',
    'agent',
    'other'
];
